import {
  Fragment,
  useCallback,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';
import _, { isUndefined } from 'lodash';
import {
  Backdrop,
  Badge,
  Box,
  Button,
  Checkbox,
  DialogContent,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  Icon,
  IconButton,
  InputLabel,
  Link,
  List,
  ListItemText,
  MenuItem,
  Paper,
  Popper,
  Radio,
  RadioGroup,
  Select,
  Switch,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import { red } from '@mui/material/colors';
import {
  ehrAPIBaseService,
  ehrAPIService,
  ehrAPIServiceFile,
} from '../../../../http-common';
import FHIRHumanName from '../../molecule/fhirHumanName';
import FHIRAddress from '../../molecule/fhirAddress';
import { paperWithTopLabelAndBottomValue } from '../../uiComponent';

import FHIRTelecom from '../../molecule/fhirTelecom';
import { patientGenderOptionsList } from '../../../../data/fhirHumanNameData';
import {
  AsyncAutoCompleteWithTopLabel,
  AutoCompleteWithTopLabel,
  CheckboxComponent,
  DateSelectorWithTopLabelComponent,
  DateTimeSelectorWithTopLabelComponent,
  SelectWithTopLabelComponent,
  TextFieldWithTopLabelComponent,
} from '../../uiComponent/fhirComponentUi';
import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'react-redux';
import {
  ACTION_CLOSE_ALL_DRAWER,
  ACTION_CLOSE_LEFT_FLOATING_DRAWER,
  ACTION_LEFT_DRAWER_JSX,
  ACTION_OPEN_TOOLBAR,
  ACTION_SET_TOOLBAR_JSX,
} from '../../../MainUIFrame/constants';
import {
  useMainFrameDispatch,
  useMainFrameState,
} from '../../../MainUIFrame/MainFrame';
import { setEditMode } from '../../../../redux/features/editModeSlice';
import {
  useNavigate,
  useLocation,
  unstable_usePrompt,
  unstable_useBlocker,
  useBeforeUnload,
} from 'react-router-dom';
import { setProgress } from '../../../../redux/features/progressSlice';
import { languageList } from '../../../../data/valueSets/languages2';
import { flatObjectFromFhirPatient } from '../../../reusableLogic/fhirComplexObjectFlatning';
import {
  setCurrentTempPatientImageArray,
  setReduxCurrentPatientObject,
} from '../../../../redux/features/currentSlice';
import EHRToolbar from '../../../Toolbar/toolbarContent';
import { forwardRef } from 'react';
import { setToolbarButtons } from '../../../../redux/features/toolbarSlice';
import { toolbarConstants } from '../../../../constants/toolbar/toolbarConstants';
import { generateNotifications } from '../../../reusableLogic';
import { useSnackbar } from 'notistack';
import {
  ACTION_OPEN_RIGHT_FLOATING_DRAWER,
  ACTION_RIGHT_DRAWER,
  ACTION_RIGHT_DRAWER_JSX,
} from '../../../../component/MainUIFrame/constants';
import AddProviderRightDrawerComponent from '../../../../pages/FHIRClaimResponse/contents/drawerContent/addProviderRightDrawerComponent.js';

import utc from 'dayjs/plugin/utc';
import { useConfirm } from 'material-ui-confirm';
import {
  resetStateDetectorState,
  setStateDetectorState,
} from '../../../../redux/features/stateDetectorSlice';
import Prompt from '../../../BlockerConfirm/blockerConfirm';
import { quickAddData } from '../../../../redux/features/quickAddDataSlice';
import CustomConfirmDialog from '../../../customConfirmationDialog';
import axios from 'axios';
import AddTaskRightDrawer from '../Task/AddTaskRightDrawer';
import TaskScreenList from '../Task/TaskListScreen';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import jwtDecode from 'jwt-decode';
import { maritalStatusArray } from '../../../../data/valueSets/maritalStatus';
import {
  ethnicity,
  ethnicityArray,
} from '../../../../data/valueSets/ethnicity';
import { raceArray } from '../../../../data/valueSets/race.js';

const patientInitailStateFromProps = ({
  data,
  currentReduxPatientObject,
  selectedVersion,
} = {}) => {
  let version1Value;
  let version1Name;

  if (selectedVersion === 'IN') {
    version1Value =
      data?.identifier?.[
        _.findIndex(
          data?.identifier,
          o => o?.type?.coding?.[0].code === 'AADHAAR'
        )
      ]?.value;
    version1Name = 'aadhaar';
  } else if (
    _.isUndefined(
      data?.identifier?.find(o => o?.type?.coding?.[0].code === 'SS')
    )
  ) {
    version1Value =
      data?.identifier?.[
        _.findIndex(
          data?.identifier,
          o => o?.type?.coding?.[0].code === 'AADHAAR'
        )
      ]?.value;
    version1Name = 'aadhaar';
  } else {
    version1Value =
      data?.identifier?.[
        _.findIndex(data?.identifier, o => o?.type?.coding?.[0].code === 'SS')
      ]?.value;
    version1Name = 'ssn';
  }

  let maritalStatus = !_.isEmpty(data?.maritalStatus?.coding[0]?.code)
    ? {
        code: data?.maritalStatus?.coding[0]?.code,
        display: data?.maritalStatus?.coding[0]?.display,
      }
    : { code: 'NS', display: 'Not Specified' };

  const ethnicityFromFhir = data?.extension?.find(element =>
    element?.url?.includes('us-core-ethnicity')
  );
  let ethnicityData = !_.isEmpty(
    ethnicityFromFhir?.valueCodeableConcept?.coding?.[0]?.code
  )
    ? {
        code: ethnicityFromFhir?.valueCodeableConcept?.coding?.[0]?.code,
        display: ethnicityFromFhir?.valueCodeableConcept?.coding?.[0]?.display,
      }
    : {
        code: 'NS',
        display: 'Not Specified',
        system: 'http://terminology.hl7.org/CodeSystem/v3-NullFlavor',
      };

  const raceFromFhir = data?.extension?.find(element =>
    element?.url?.includes('us-core-race')
  );
  let raceData = !_.isEmpty(
    raceFromFhir?.valueCodeableConcept?.coding?.[0]?.code
  )
    ? {
        code: raceFromFhir?.valueCodeableConcept?.coding?.[0]?.code,
        display: raceFromFhir?.valueCodeableConcept?.coding?.[0]?.display,
      }
    : {
        code: 'NS',
        display: 'Not Specified',
        system: 'http://terminology.hl7.org/CodeSystem/v3-NullFlavor',
      };

  return {
    id: data?.id,
    resourceType: data?.resourceType,
    name: data?.name,
    gender: !_.isUndefined(data?.gender) ? data?.gender : '',
    birthDate: !_.isUndefined(data?.birthDate) ? data?.birthDate : '',
    telecom: data?.telecom,
    address: data?.address,
    identifier: data?.identifier,
    photo: data?.photo,
    languageObject: {
      code: data?.communication?.[0]?.language?.coding?.[0]?.code,
      display: data?.communication?.[0]?.language?.coding?.[0]?.display,
    },
    meta: data?.meta,
    managingOrganizationObject:
      currentReduxPatientObject?.managingOrganizationObject,
    primaryCareObject: currentReduxPatientObject?.primaryCareObject,
    generalPractitionerObject:
      currentReduxPatientObject?.generalPractitionerObject,
    [version1Name]: version1Value,

    // active: Boolean(data?.deceasedBoolean)
    //   ? 'deceased'
    //   :
    active: !_.isUndefined(data?.active) ? data?.active : true,

    raw: data,
    pregnancyObject: currentReduxPatientObject?.pregnancyObject,
    breastFeedingObject: currentReduxPatientObject?.breastFeedingObject,
    isPregnant: currentReduxPatientObject?.pregnancyObject?.isPregnant,
    isBreastFeeding:
      currentReduxPatientObject?.breastFeedingObject?.isBreastFeeding,
    isDeceased: Boolean(data?.deceasedBoolean || data?.deceasedDateTime),
    deceasedDateTime: data?.deceasedDateTime,
    maritalStatus: maritalStatus,
    ethnicity: ethnicityData,
    race: raceData,
  };
};

const FHIRPatient = forwardRef((props, ref) => {
  dayjs.extend(utc);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const { isCreate } = props;
  const addressRef = useRef();
  const humanNameRef = useRef();
  const telecomRef = useRef();
  const languageRef = useRef();
  const selectedVersion = useSelector(
    state => state.changeVersion.selectedVersion
  );
  const [switchLoading, setSwitchLoading] = useState(false);

  const confirmation = CustomConfirmDialog;

  const [initialState, setInitialState] = useState({});

  const [isStateChanged, setIsStateChanged] = useState(false);
  const [loading, setLoading] = useState(false);

  const [showTaskListScreen, setShowTaskListScreen] = useState(false);

  const currentReduxPatientObject = useSelector(
    state => state?.current?.currentPatientObject
  );

  const currentReduxTempPatientImageArray = useSelector(
    state => state?.current?.currentTempPatientImageArray
  );

  const isPatientStateChanged = useSelector(
    state => state?.stateDetector?.isPatientStateChanged
  );

  const navigate = useNavigate();

  const [searchType, setSearchType] = useState(
    !isUndefined(
      currentReduxPatientObject?.primaryCareObject?.code?.split('/')?.[0]
    )
      ? currentReduxPatientObject?.primaryCareObject?.code
          ?.split('/')?.[0]
          ?.toLowerCase()
      : 'organization'
  );

  const [isdeceasedClicked, setDeceasedClicked] = useState(false);

  const editMode = useSelector(state => {
    return state?.edit?.editMode;
  });

  const isEdit = editMode;
  const patientObject = props?.patientObject;

  const [notificationSettings, setNotificationSetting] = useState({
    sms: false,
    email: false,
  });

  const [notificationState, setNotificationState] = useState({});

  const [personsData, setPersonsData] = useState([]);
  const [selectedPersonData, setSelectedPersonData] = useState(null);
  const [relationshipData, setRelationshipData] = useState(null);
  const [relationship, setRelationship] = useState(null);

  const handlePersonSelect = event => {
    const data = event.target.value;
    setSelectedPersonData(data);
  };

  const selectedPerson = personsData?.[0]?.entry?.find(
    person => person?.resource?.id === selectedPersonData?.resource?.id
  );

  useEffect(() => {
    // debugger;
    const idArray = selectedPersonData?.resource?.link?.map?.(item => {
      const targetReference = item?.target?.reference;
      return targetReference?.split('/')?.[1];
    });
    const filteredResult = relationshipData?.find?.(relationship => {
      const relationshipId = relationship?.resource?.id;
      return idArray?.some(id => relationshipId === id);
    });
    setRelationship(filteredResult);
  }, [selectedPersonData, relationshipData]);

  const [patientState, setPatientState] = useState(
    patientInitailStateFromProps({
      data: patientObject,
      currentReduxPatientObject,
      selectedVersion,
    })
  );

  useEffect(() => {
    setInitialState(patientState);
    setNotificationState(notificationSettings);
  }, []);

  useEffect(() => {
    const flag = JSON.stringify(patientState) !== JSON.stringify(initialState);
    setIsStateChanged(flag);
    reduxDispatch(setStateDetectorState({ isBasePatientStateChanged: flag }));
    console.log(`IS_STATE_CHANGED_PATIENT`, flag);
  }, [patientState, initialState]);

  useEffect(() => {
    const notificationStateChanged =
      JSON.stringify(notificationSettings) !==
      JSON.stringify(notificationState);

    setIsStateChanged(notificationStateChanged);
    reduxDispatch(
      setStateDetectorState({
        isBasePatientStateChanged: notificationStateChanged,
      })
    );
    console.log(`IS_STATE_CHANGED_PATIENT`, notificationStateChanged);
  }, [notificationSettings, notificationState]);

  useImperativeHandle(ref, () => ({
    handleOnClick: () =>
      handleOnClick(
        !_.isUndefined(patientState?.id) ? 'fullUpdate' : 'createRecord'
      ),
  }));

  const dispatch = useMainFrameDispatch();

  const genderRef = useRef(null);
  const birthDateRef = useRef(null);
  const deceasedDateTimeRef = useRef(null);
  const aadhaarRef = useRef(null);
  const ssnRef = useRef(null);
  const primaryCareRef = useRef(null);
  const managingOrganizationRef = useRef(null);
  const generalPractitionerRef = useRef(null);
  const personRef = useRef(null);
  const relationshipRef = useRef(null);
  const activeRef = useRef(null);
  const { isDark } = useMainFrameState();
  const [refresh, setRefresh] = useState(false);
  const { isRightDrawerOpen } = useMainFrameState();

  const reduxDispatch = useDispatch();

  const genderValidationObject = {
    name: 'gender',
    value: patientState?.gender,
    label: 'Gender',
    ref: genderRef,
    width: '90%',
    optionsList: patientGenderOptionsList,
    validation: {
      required: true,
    },
  };

  const birthDateValidationObject = {
    name: 'birthDate',
    value: patientState?.birthDate,
    label: 'Birth Date',
    format: 'MM/dd/yyyy',
    // format: 'dd/MM/yyyy',
    ref: birthDateRef,
    width: '90%',
    validation: {
      required: true,
    },
  };

  const deceasedDateTimeValidationObject = {
    name: 'deceasedDateTime',
    value: patientState?.deceasedDateTime,
    label: 'Deceased On',
    flip: true,
    disableFuture: true,
    format: 'MM/dd/yyyy HH:mm',
    ref: deceasedDateTimeRef,
    width: '90%',
    validation: {
      required: true,
    },
  };

  const ValidationObject1 = (patientState, selectedVersion) => {
    let name;
    let value;
    let ref;
    let label;
    let validation;
    let mask;
    let maxLength;

    if (selectedVersion === 'IN') {
      name = 'aadhaar';
      value = patientState?.aadhaar;
      ref = aadhaarRef;
      label = 'AADHAAR';
      validation = {
        required: false,
        min: 12,
        max: 12,
      };
      mask = '9999-9999-9999';
      maxLength = 12;
    } else {
      name = 'ssn';
      value = patientState?.ssn;
      ref = ssnRef;
      label = 'SSN';
      validation = {
        required: false,
        min: 4,
        max: 9,
      };
      mask = patientState?.ssn?.length > 4 ? '999-99-9999' : '(9999)';
      maxLength = 9;
    }

    return {
      name,
      value,
      label,
      ref,
      width: '95%',
      validation,
      mask,
      maxLength,
    };
  };

  const activeValidationObject = {
    name: 'active',
    value: patientState?.active,
    label: 'Status',
    optionsList: [
      { code: true, display: 'Active' },
      { code: false, display: 'Inactive' },
      // { code: 'deceased', display: 'Deceased' },
    ],
    ref: activeRef,
  };

  const pregnancyCheckboxValidationObject = {
    name: 'isPregnant',
    title: 'Pregnant',
    value: patientState?.isPregnant,
  };

  const breastFeedingCheckboxValidationObject = {
    name: 'isBreastFeeding',
    title: 'Breast Feeding',
    value: patientState?.isBreastFeeding,
  };

  const [primaryCareOptionsList, setPrimaryCareOptionsList] = useState([]);
  const [generalPractitionerOptionsList, setGeneralPractitionerOptionsList] =
    useState([]);
  const [managingOrganizationOptionsList, setManagingOrganizationOptionsList] =
    useState([]);

  const [optionsListRetrieved, setOptionsListRetrieved] = useState(false);
  const getOrganizationData = async (type, searchText) => {
    try {
      let searchQuery = `search/?_elements=name,type&_sort=name&_type=Organization,Practitioner`;
      if (searchText && !_.isEmpty(searchText)) {
        searchQuery += `&_content:contains=${searchText}`;
      }
      const response = await ehrAPIService.get(searchQuery);

      let organizationProvArray = [];
      let gpArray = [];
      let organizationNotProvAndInsArray = [];

      for (let item of response?.data?.entry) {
        if (item?.resource?.resourceType?.toLowerCase() === 'organization') {
          if (item?.resource?.type?.[0]?.coding?.[0]?.code === 'prov') {
            organizationProvArray.push(item?.resource);
          }
          organizationNotProvAndInsArray.push(item?.resource);
        } else {
          organizationProvArray.push(item?.resource);
          gpArray.push(item?.resource);
        }
      }

      for (let type_ of type) {
        switch (type_) {
          case 'gp':
            let optionsArrayGP = [];
            for (let item of gpArray) {
              let obj = {
                display: item?.name?.[0]?.text,
                code: `${item?.resourceType}/${item?.id}`,
                data: item,
              };
              optionsArrayGP.push(obj);
            }

            setGeneralPractitionerOptionsList(optionsArrayGP);
            break;

          case 'prov':
            let optionsArray = [];
            for (let item of organizationProvArray) {
              let obj = {
                display:
                  item?.resourceType?.toLowerCase() === 'organization'
                    ? item?.name
                    : item?.name?.[0]?.text,
                code: `${item?.resourceType}/${item?.id}`,
                data: item,
              };
              optionsArray.push(obj);
            }

            setPrimaryCareOptionsList(optionsArray);
            break;
          case 'org':
            let optionsArrayOrg = [];
            for (let item of organizationNotProvAndInsArray) {
              let obj = {
                display: item?.name,
                code: `${item?.resourceType}/${item?.id}`,
                data: item,
              };

              optionsArrayOrg.push(obj);
            }
            setManagingOrganizationOptionsList(optionsArrayOrg);
            break;
          default:
            break;
        }
      }
      setOptionsListRetrieved(true);
    } catch (e) {
      console.error(`fhirPatient->getOrganizationAndPractionerData`, e);
    }
  };

  useEffect(() => {
    if (_.isUndefined(patientObject?.id)) {
      reduxDispatch(setEditMode(true));
    }

    dispatch({ type: ACTION_CLOSE_ALL_DRAWER });
    dispatch({ type: ACTION_OPEN_TOOLBAR });
    if (
      _.isEmpty(managingOrganizationOptionsList) &&
      _.isEmpty(primaryCareOptionsList) &&
      _.isEmpty(generalPractitionerOptionsList)
    ) {
      getOrganizationData(['prov', 'gp', 'org']);
    }
    return () => {
      dispatch({ type: ACTION_CLOSE_ALL_DRAWER });
    };
  }, []);

  useEffect(() => {}, [optionsListRetrieved, props]);

  const handleOpenRightProviderDrawers = name => {
    const isBillingManaging = name === 'billing_managing';
    const drawerSearchType = isBillingManaging ? 'organization' : searchType;
    dispatch({ type: ACTION_RIGHT_DRAWER });
    dispatch({
      type: ACTION_RIGHT_DRAWER_JSX,
      payload: (
        <AddProviderRightDrawerComponent
          setRefresh={setRefresh}
          refresh={refresh}
          type={isBillingManaging ? 'billing' : name}
          searchType={drawerSearchType}
          isDisable={isBillingManaging}
          fhirPatientHide={true}
        />
      ),
    });
    dispatch({ type: ACTION_OPEN_RIGHT_FLOATING_DRAWER });
  };

  const searchPerson = async patientId => {
    try {
      setLoading(true);
      const url = `/search/RelatedPerson?patient=${patientId}`;
      const response = await ehrAPIService.get(url);
      const relatedPersons = response?.data?.entry;
      // debugger;
      setRelationshipData(relatedPersons);
      const relatedPersonIds = relatedPersons?.map(relatedPerson => {
        console.log(relatedPerson);
        return relatedPerson?.resource?.id;
      });
      const persons = [];
      const personUrl = `search/Person?link=RelatedPerson/${relatedPersonIds?.join(
        ','
      )}`;
      const personResponse = await ehrAPIService.get(personUrl);
      persons.push(personResponse.data);
      setPersonsData(persons);
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    reduxDispatch(
      quickAddData({
        componentName: 'PrimaryCareObject',
        display: '',
        code: '',
        label: '',
        value: '',
        raw: '',
      })
    );
  }, [searchType]);

  const primaryCareValidationObject = {
    name: 'primaryCareObject',
    value: patientState?.primaryCareObject,
    label: searchType === 'organization' ? 'Organization' : 'Practitioner',
    // optionsList: primaryCareOptionsList,
    ref: primaryCareRef,
    validation: {
      required: true,
    },
    urlType: 'fhir',
    url:
      searchType === 'organization'
        ? `fhir/search/Organization?name:contains=`
        : `fhir/search/Practitioner?name:contains=`,
    noOptionstext:
      searchType === 'organization'
        ? 'Add new Organization'
        : 'Add new Practitioner',
    noOptionstype: 'billing',
    noOptionsdrawer: handleOpenRightProviderDrawers,
    zIndex: 1000,
  };

  const generalPractitionerValidationObject = {
    name: 'generalPractitionerObject',
    // value: patientState?.generalPractitionerObject,
    value: patientState?.generalPractitionerObject,
    label: 'General Practitioner',
    urlType: 'fhir',
    url: `fhir/search/Practitioner?name:contains=`,
    // optionsList: generalPractitionerOptionsList,
    ref: generalPractitionerRef,
    noOptionstext: 'Add new General Practitioner',
    noOptionstype: 'rendering',
    noOptionsdrawer: handleOpenRightProviderDrawers,
    zIndex: 1000,
  };

  const managingOrganizationValidationObject = {
    name: 'managingOrganizationObject',
    // value: patientState?.managingOrganizationObject,
    value: patientState?.managingOrganizationObject,
    label: 'Managing Organization',
    urlType: 'fhir',
    url: `fhir/search/Organization?name:contains=`,
    // optionsList: managingOrganizationOptionsList,
    ref: managingOrganizationRef,
    noOptionstype: 'billing_managing',
    noOptionstext: 'Add new Managing Organization',
    noOptionsdrawer: handleOpenRightProviderDrawers,
    zIndex: 1000,
  };

  // const contactPersonValidationObject = {
  //     name: 'person',
  //     value: patientState?.person,
  //     // value: ,
  //     label: 'Contact Person',
  //     urlType: 'fhir',
  //     url: `fhir/search/Person?name:contains=`,
  //     // optionsList: languageList,
  //     ref: personRef,

  //     // zIndex: 1000,
  // };

  // const relationshipValidationObject = {
  //     name: 'relationship',
  //     value: patientState?.relationship,
  //     // value: ,
  //     label: 'Relationship',
  //     // urlType: 'fhir',
  //     // url: `fhir/search/Person?name:contains=`,
  //     optionsList: relationshipOptionsList,
  //     ref: relationshipRef,

  //     // zIndex: 1000,
  // };

  const languageValidationObject = {
    name: 'languageObject',
    value: !_.isUndefined(patientState?.languageObject?.code)
      ? patientState?.languageObject
      : { code: 'en', display: '' },
    label: 'Preferred Language',
    optionsList: languageList,
    ref: languageRef,
    zIndex: 1000,
  };

  const maritalStatusRef = useRef(null);

  const maritalStatusValidationObject = {
    name: 'maritalStatus',
    value: patientState?.maritalStatus,
    label: 'Marital Status',
    optionsList: maritalStatusArray,
    ref: maritalStatusRef,
    zIndex: 1000,
  };

  const ethnicityValidationObject = {
    name: 'ethnicity',
    value: patientState?.ethnicity,
    label: 'Ethnicity',
    optionsList: ethnicityArray,
    zIndex: 1000,
  };

  const raceValidationObject = {
    name: 'race',
    value: patientState?.race,
    label: 'Race',
    optionsList: raceArray,
    zIndex: 1000,
  };

  const [openIdentityDrawer, setOpenIdentityDrawer] = useState(false);

  const [openInsuranceDrawer, setOpenInsuranceDrawer] = useState(false);

  useEffect(() => {
    let name = '';
    let payload = false;
    if (openIdentityDrawer) {
      name = 'identityUpload';
      payload = true;
    }

    if (openInsuranceDrawer) {
      name = 'insuranceUpload';
      payload = true;
    }

    let parcelableObject = { name, payload };

    props?.handleOnCallback(parcelableObject);
  }, [openIdentityDrawer, openInsuranceDrawer]);

  const [isIdentityExists, setIsIdentityExists] = useState(false);
  const [isInsuranceExists, setIsInsuranceExists] = useState(false);

  useEffect(() => {
    dispatch({
      type: ACTION_SET_TOOLBAR_JSX,
      payload: <EHRToolbar />,
    });
    patientObject?.identifier?.forEach(idf => {
      if (
        idf?.type?.coding?.[0]?.code === 'NI' ||
        idf?.type?.coding?.[0]?.code === 'DL' ||
        idf?.type?.coding?.[0]?.code === 'PPN'
      ) {
        setIsIdentityExists(true);
      }

      if (idf?.type?.coding?.[0]?.code === 'NII') {
        setIsInsuranceExists(true);
      }
    });
  }, [patientObject]);

  const [currentNameObject, setCurrentNameObject] = useState(
    !_.isUndefined(
      patientState?.name?.[
        _.findIndex(patientState?.name, o => o?.use === 'official')
      ]
    )
      ? patientState?.name?.[
          _.findIndex(patientState?.name, o => o?.use === 'official')
        ]
      : {
          use: '',
          text: '',
          family: '',
          given: [],
          prefix: [],
          suffix: [],
        }
  );

  const [currentAddressObject, setCurrentAddressObject] = useState({
    official: !_.isUndefined(
      patientState?.address?.[
        _.findIndex(patientState?.address, o => o?.use === 'home')
      ]
    )
      ? patientState?.address?.[
          _.findIndex(patientState?.address, o => o?.use === 'home')
        ]
      : {
          use: 'home',
          type: 'postal',
          text: '',
          line: [],
          city: '',
          district: '',
          state: '',
          postalCode: '',
          country: '',
        },
    billing: !_.isUndefined(
      patientState?.address?.[
        _.findIndex(patientState?.address, o => o?.use === 'work')
      ]
    )
      ? patientState?.address?.[
          _.findIndex(patientState?.address, o => o?.use === 'work')
        ]
      : {
          use: 'work',
          type: 'postal',
          text: '',
          line: [],
          city: '',
          district: '',
          state: '',
          postalCode: '',
          country: '',
        },
  });

  useEffect(() => {
    console.log(`PTX`, patientState);

    setCurrentNameObject(
      patientState?.name?.[
        _.findIndex(patientState?.name, o => o?.use === currentNameObject?.use)
      ]
    );

    setCurrentAddressObject({
      official: !_.isUndefined(
        patientState?.address?.[
          _.findIndex(patientState?.address, o => o?.use === 'home')
        ]
      )
        ? patientState?.address?.[
            _.findIndex(patientState?.address, o => o?.use === 'home')
          ]
        : {
            use: 'home',
            type: 'postal',
            text: '',
            line: [],
            city: '',
            district: '',
            state: '',
            postalCode: '',
            country: '',
          },
      billing: !_.isUndefined(
        patientState?.address?.[
          _.findIndex(patientState?.address, o => o?.use === 'work')
        ]
      )
        ? patientState?.address?.[
            _.findIndex(patientState?.address, o => o?.use === 'work')
          ]
        : {
            use: 'work',
            type: 'postal',
            text: '',
            line: [],
            city: '',
            district: '',
            state: '',
            postalCode: '',
            country: '',
          },
    });
  }, [patientState]);

  const location = useLocation();

  useEffect(() => {
    setPatientState(
      patientInitailStateFromProps({
        data: patientObject,
        currentReduxPatientObject,
      })
    );
  }, [patientObject]);

  useEffect(() => {
    reduxDispatch(
      setToolbarButtons({
        actions: [
          {
            key: toolbarConstants.CREATE,
            clickAction: () => {
              reduxDispatch(setProgress(true));
              flatObjectFromFhirPatient({}).then(() => {
                reduxDispatch(setEditMode(false));
                setPatientState({});
                reduxDispatch(setReduxCurrentPatientObject({}));
                reduxDispatch(setCurrentTempPatientImageArray([]));
                reduxDispatch(setProgress(false));
                reduxDispatch(setEditMode(true));
                navigate('/ehr/record', {
                  isCreate: true,
                });
              });
            },
            disabled: true,
          },
          {
            key: toolbarConstants.SAVE,
            clickAction: () =>
              handleOnClick({
                state: {
                  ...patientState,
                  isStateChanged,
                  reduxObject: currentReduxPatientObject,
                },
              }),
            disabled: !editMode || showTaskListScreen,
          },
          {
            key: toolbarConstants.CANCEL,
            clickAction: () => {
              if (showTaskListScreen) {
                setShowTaskListScreen(false);
              } else {
                navigate(`/ehr`);
              }
            },
          },
        ],
        module: 'Patient',
        editSwitch: !location.pathname.split('/').includes('new'),
      })
    );
    return () => {
      reduxDispatch(setToolbarButtons({ actions: [] }));
    };
  }, [
    patientState,
    isStateChanged,
    isDark,
    currentReduxPatientObject,
    showTaskListScreen,
    props?.addNewAnnotationText,
  ]);

  const handleOnChange = event => {
    const { name, value } = event?.target;

    if (name === 'use') {
      if (
        _.isUndefined(
          patientState?.name[
            _.findIndex(patientState?.name, o => o.use === value)
          ]
        )
      ) {
        setCurrentNameObject({
          [name]: value,
        });
      } else {
        setCurrentNameObject(
          patientState?.name[
            _.findIndex(patientState?.name, o => o.use === value)
          ]
        );
      }
    } else if (name === 'useAddress') {
      if (
        !_.isUndefined(
          patientState?.address[
            _.findIndex(patientState?.address, o => o.use === value)
          ]
        )
      ) {
        setCurrentAddressObject(
          patientState?.address[
            _.findIndex(patientState?.address, o => o.use === value)
          ]
        );
      } else {
        setCurrentAddressObject({
          [name]: value,
        });
      }
    } else {
      setPatientState({
        ...patientState,
        [name]: value,
      });
    }
  };

  const getUserSetting = async () => {
    setSwitchLoading(true);
    try {
      let UserSetting = await ehrAPIBaseService.get(
        `fhir/search/?resourceType=Basic&code=user.notificationSettings&subject=Patient/${patientState?.id}`
      );
      if (UserSetting?.data?.entry) {
        const value = UserSetting?.data?.entry?.[0]?.resource?.extension?.find(
          o => o?.url === 'http://enliv.com/notificationSettings'
        )?.valueString;
        setNotificationSetting(JSON.parse(value));
      } else {
        setNotificationSetting({
          sms: false,
          email: false,
        });
      }
    } catch (e) {
      console.error('error:', e);
    } finally {
      setSwitchLoading(false);
    }
  };
  useEffect(() => {
    getUserSetting();
  }, [patientState?.id]);

  // const updatePerson = async (relatedPersonId, fhirPersonId) => {
  //     let param = {
  //         resourceType: 'Person',
  //         name: [patientState?.person?.raw?.name?.[0]],
  //         telecom: patientState?.person?.raw?.telecom,
  //         gender: patientState?.person?.raw?.gender,
  //         birthDate: dayjs(patientState?.person?.raw?.birthDate).format(
  //             'YYYY-MM-DD'
  //         ),
  //         active: true,
  //     };
  //     if (fhirPersonId) {
  //         param.id = fhirPersonId;
  //     }
  //     if (relatedPersonId) {
  //         param.link = [
  //             {
  //                 target: {
  //                     reference: `RelatedPerson/${relatedPersonId}`,
  //                 },
  //                 assurance: 'level1',
  //             },
  //         ];
  //         param.address = patientState?.person?.raw?.address;
  //     }
  //     try {
  //         reduxDispatch(setProgress(true));
  //         const response = await ehrAPIService.put(`updateResource`, param);
  //         console.log(response);
  //     } catch (e) {
  //         console.log('catch block');
  //         console.error(e);
  //     } finally {
  //         reduxDispatch(setProgress(false));
  //     }
  // };

  // const createRelatedPerson = async patientData => {
  //     let param = {};
  //     param.name = [patientState?.person?.raw?.name?.[0]];
  //     param.address = patientState?.person?.raw?.address;
  //     param.gender = patientState?.person?.raw?.gender;
  //     param.birthDate = dayjs(patientState?.person?.raw?.birthDate).format(
  //         'YYYY-MM-DD'
  //     );
  //     param.resourceType = 'RelatedPerson';
  //     param.telecom = patientState?.person?.raw?.telecom;
  //     param.patient = {
  //         reference: `Patient/${patientData?.id}`,
  //         type: 'Patient',
  //         display: patientData?.name?.[0]?.text,
  //     };
  //     param.relationship = [
  //         {
  //             coding: [
  //                 {
  //                     system: 'http://terminology.hl7.org/CodeSystem/v3-RoleCode',
  //                     code: patientState?.relationship?.value,
  //                     display: _.capitalize(
  //                         patientState?.relationship?.value
  //                     ),
  //                 },
  //             ],
  //         },
  //     ];
  //     console.log(`relatedpersonObject`, param);

  //     try {
  //         reduxDispatch(setProgress(true));
  //         const response = await ehrAPIService.post(`createResource`, param);

  //         updatePerson(response?.data?.id, patientState?.person?.raw?.id);
  //     } catch (e) {
  //         console.log('catch block');
  //         console.error(e);
  //     } finally {
  //         reduxDispatch(setProgress(false));
  //     }
  // };

  const observationSkeleton = {
    resourceType: 'Observation',
    status: 'final',
    subject: {
      reference: '',
    },
    effectiveDateTime: '',
  };

  let skeleton = {
    category: [
      {
        coding: [
          {
            code: 'survey',
            display: 'Survey',
            system:
              'http://terminology.hl7.org/CodeSystem/observation-category',
          },
        ],
        text: 'Survey',
      },
    ],
    code: {},
    effectiveDateTime: '',
    resourceType: 'Observation',
    status: 'final',
    subject: {
      reference: '',
    },
    valueQuantity: {
      unit: '',
      value: '',
    },
  };

  const isPatientPageStateChanged = () => {
    let nameObj = humanNameRef?.current?.handleOnUpdate();
    let addressList = addressRef?.current?.handleOnUpdate();
    let telecomArray = telecomRef?.current?.handleOnUpdate();

    return (
      isStateChanged ||
      nameObj?.isStateChanged ||
      addressList?.isStateChanged ||
      telecomArray?.isStateChanged
    );
  };

  const mimeToExt = {
    'image/jpeg': 'jpg',
    'image/png': 'png',
    'image/gif': 'gif',
    'image/webp': 'webp',
    'image/tiff': 'tif',
    'application/pdf': 'pdf',
    // ... add other mappings as needed
  };

  function getMimeTypeAndExtension(base64String) {
    const match = base64String?.match(
      /data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/
    );
    if (match && match?.length > 1) {
      const mimeType = match?.[1];
      const extension = mimeToExt[mimeType] || null;
      return { mimeType, extension };
    }
    return { mimeType: null, extension: null };
  }

  function base64ToBlob(base64) {
    const parts = base64.split(';');
    const mimeType = parts[0].split(':')[1];
    const bytes = atob(parts[1].split(',')[1]);

    let buffer = new Uint8Array(bytes.length);
    for (let i = 0; i < bytes.length; i++) {
      buffer[i] = bytes.charCodeAt(i);
    }

    return new Blob([buffer], { type: mimeType });
  }

  const handleOnAssignTask = () => {
    dispatch({
      type: ACTION_RIGHT_DRAWER_JSX,
      payload: <AddTaskRightDrawer />,
    });

    dispatch({ type: ACTION_OPEN_RIGHT_FLOATING_DRAWER });
  };

  const handleOnClick = async event => {
    let nameObj = humanNameRef?.current?.handleOnUpdate();
    let addressList = addressRef?.current?.handleOnUpdate();
    let telecomArray = telecomRef?.current?.handleOnUpdate();

    let genderObj = genderRef?.current?.onValidate();
    let birtDateObject = birthDateRef?.current?.onValidate();
    let deceasedDateTimeObject = patientState?.isDeceased
      ? deceasedDateTimeRef?.current?.onValidate()
      : false;
    let validateObject = selectedVersion === 'IN' ? aadhaarRef : ssnRef;
    let validationValue1 = validateObject?.current?.onValidate();

    const pcRawObj = primaryCareRef?.current?.onValidate();

    let currentPatient = event?.state;

    if (
      !(
        currentPatient?.isStateChanged ||
        nameObj?.isStateChanged ||
        addressList?.isStateChanged ||
        telecomArray?.isStateChanged
      ) &&
      currentPatient?.id
    ) {
      try {
        const options = {
          message: 'No data changed. Do you still want to save?',
          isDark,
        };
        await confirmation(options);
      } catch (e) {
        return;
      }
    }

    if (
      nameObj?.valid &&
      addressList?.valid &&
      telecomArray?.valid &&
      validationValue1?.valid &&
      pcRawObj?.isValid &&
      genderObj?.valid &&
      birtDateObject?.valid &&
      (!patientState?.isDeceased ||
        (patientState?.isDeceased && deceasedDateTimeObject?.valid))
    ) {
      delete nameObj.valid;
      delete addressList.valid;
      delete telecomArray.valid;
      delete nameObj.isStateChanged;
      delete addressList.isStateChanged;
      delete telecomArray.isStateChanged;
      delete deceasedDateTimeObject?.valid;

      let identifierObj1 = {
        use: 'usual',
        type: {
          coding: [
            {
              system: 'http://terminology.hl7.org/CodeSystem/v2-0203',
              code: '',
              userSelected: false,
            },
          ],
        },
        system: 'http://hl7.org/fhir/sid/us-ssn',
        value: 0,
      };
      if (selectedVersion === 'IN') {
        identifierObj1.type.coding[0].code = 'AADHAAR';
        identifierObj1.system = 'http://hl7.org/fhir/sid/us-ssn';
        identifierObj1.value = validationValue1?.value;
      } else {
        identifierObj1.type.coding[0].code = 'SS';
        identifierObj1.system = 'http://hl7.org/fhir/sid/us-ssn';
        identifierObj1.value = validationValue1?.value;
      }

      let param = {};
      param.name = [nameObj];
      param.address = addressList;
      param.gender = genderObj?.value;
      param.birthDate = dayjs(birtDateObject?.value).format('YYYY-MM-DD');
      param.resourceType = 'Patient';

      if (currentPatient?.photo) {
        param.photo = currentPatient?.photo;
      }

      param.identifier = [identifierObj1];
      if (!_.isEmpty(currentPatient?.identifier)) {
        let filteredIdentifier;

        if (selectedVersion === 'IN') {
          filteredIdentifier = currentPatient?.identifier?.filter(
            o => o?.type?.coding?.[0]?.code !== 'AADHAAR'
          );
        } else {
          filteredIdentifier = currentPatient?.identifier?.filter(
            o => o?.type?.coding?.[0]?.code !== 'SS'
          );
        }
        param.identifier = [...filteredIdentifier, identifierObj1];
      }

      param.telecom = telecomArray;

      const gpRawObj = generalPractitionerRef?.current?.onValidate();
      const mpRawObj = managingOrganizationRef?.current?.onValidate();
      const personObj = personRef?.current?.onValidate();
      const relationship = relationshipRef?.current?.onValidate();
      const activeRawObj = activeRef?.current?.onValidate();
      const languageObject = languageRef?.current?.onValidate();

      if (!pcRawObj?.isValid) {
        return;
      }

      let languageCodableConcept = {
        coding: [
          {
            system: 'http://terminology.hl7.org/CodeSystem/designation-usage',
            code: languageObject?.value?.code,
            display: languageObject?.value?.display,
          },
        ],
        text: languageObject?.value?.display,
      };

      let communication = [
        {
          language: languageCodableConcept,
          preferred: true,
        },
      ];

      param.communication = communication;

      let maritalStatusCodeableConcept = {
        coding: [
          {
            system: 'http://terminology.hl7.org/CodeSystem/v3-MaritalStatus',
            code: patientState?.maritalStatus?.code,
            display: patientState?.maritalStatus?.display,
          },
        ],
      };
      if (patientState?.maritalStatus?.code !== 'NS') {
        param.maritalStatus = maritalStatusCodeableConcept;
      }

      if (!patientState?.isDeceased)
        param.deceasedBoolean = patientState?.isDeceased;
      if (patientState?.isDeceased)
        param.deceasedDateTime = dayjs(patientState?.deceasedDateTime);
      param.active = activeRawObj?.value;

      const ethnicityExtension = {
        url: 'http://example.org/fhir/StructureDefinition/us-core-ethnicity',
        valueCodeableConcept: {
          coding: [
            {
              system: patientState?.ethnicity?.system,
              code: patientState?.ethnicity?.code,
              display: patientState?.ethnicity?.display,
            },
          ],
        },
      };

      const raceExtension = {
        url: 'http://example.org/fhir/StructureDefinition/us-core-race',
        valueCodeableConcept: {
          coding: [
            {
              system: patientState?.race?.system,
              code: patientState?.race?.code,
              display: patientState?.race?.display,
            },
          ],
        },
      };
      param.extension = [];
      if (patientState?.ethnicity?.code !== 'NS') {
        param.extension.push(ethnicityExtension);
      }
      if (patientState?.race?.code !== 'NS') {
        param.extension.push(raceExtension);
      }

      let generalPractitioner = [];

      if (!_.isUndefined(pcRawObj?.value?.code)) {
        generalPractitioner.push({
          reference: pcRawObj?.value?.code,
        });
      }

      if (!_.isUndefined(gpRawObj?.value?.code)) {
        generalPractitioner.push({
          reference: gpRawObj?.value?.code,
        });
      }

      if (
        _.isUndefined(pcRawObj?.value?.code) &&
        _.isUndefined(gpRawObj?.value?.code)
      ) {
        generalPractitioner = [];
      }

      if (!_.isUndefined(mpRawObj?.value?.code)) {
        param.managingOrganization = {
          reference: mpRawObj?.value?.code,
        };
      }
      if (!_.isEmpty(generalPractitioner)) {
        param.generalPractitioner = generalPractitioner;
      }

      let pregnancyObservationSkeleton = { ...observationSkeleton };
      let breastfeedingObservationSkeleton = { ...observationSkeleton };

      if (genderObj?.value === 'female') {
        const pregnancyStatusCode = {
          coding: [
            {
              system: 'http://loinc.org',
              code: '82810-3',
              display: 'Pregnancy status',
            },
          ],
        };

        const breastFeedingCode = {
          coding: [
            {
              system: 'http://loinc.org',
              code: '63895-7',
              display: 'Breastfeeding status',
            },
          ],
        };

        let valueCodeableConceptForPregnancy = {
          coding: [
            {
              system: 'http://loinc.org',
              code: 'LA26683-5',
              display: 'Not pregnant',
            },
          ],
        };

        if (patientState?.isPregnant) {
          valueCodeableConceptForPregnancy = {
            coding: [
              {
                system: 'http://loinc.org',
                code: 'LA15173-0',
                display: 'Pregnant',
              },
            ],
          };
        }

        let valueCodeableConceptForBreastFeeding = {
          coding: [
            {
              system: 'http://loinc.org',
              code: 'LA29253-4',
              display: 'Not currently breastfeeding',
            },
          ],
        };

        if (patientState?.isBreastFeeding) {
          valueCodeableConceptForBreastFeeding = {
            coding: [
              {
                system: 'http://loinc.org',
                code: 'LA29252-6',
                display: 'Currently breastfeeding',
              },
            ],
          };
        }

        pregnancyObservationSkeleton.code = pregnancyStatusCode;
        pregnancyObservationSkeleton.valueCodeableConcept =
          valueCodeableConceptForPregnancy;

        breastfeedingObservationSkeleton.code = breastFeedingCode;
        breastfeedingObservationSkeleton.valueCodeableConcept =
          valueCodeableConceptForBreastFeeding;
      }

      let type = 'info';
      let notificationTitle = '';
      let notificationDescription = '';
      try {
        reduxDispatch(setProgress(true));
        let response = null;

        if (currentPatient?.reduxObject?.extractedBase64Image) {
          let filenameWithoutExtension = `${Date.now()}_extracted_image`;
          const { mimeType, extension } = getMimeTypeAndExtension(
            currentPatient?.reduxObject?.extractedBase64Image
          );
          // let finalfileName = `${filenameWithoutExtension}.${extension}`;

          let finalfileName = `${
            patientState?.id || Date.now()
          }/${filenameWithoutExtension}/avatar.${extension}`;
          const finalBlob = base64ToBlob(
            currentPatient?.reduxObject?.extractedBase64Image
          );

          reduxDispatch(setProgress(true));

          let response1 = await ehrAPIServiceFile.get(
            `getSingleFileUploadUrl/?fileName=${finalfileName}`
          );

          response1 = response1?.data;
          await axios({
            url: response1,
            method: 'PUT',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
            },
            data: finalBlob,
          });

          param.photo = [
            {
              url: finalfileName,
            },
          ];
        }

        if (patientState?.id) {
          param.id = patientState?.id;
          param.meta = patientState?.meta;
          response = await ehrAPIService.put(`updateResource`, param);
          notificationTitle = 'Patient Record Updated Successfully';
          notificationDescription = `Patient Record Updated Successfully`;
        } else {
          reduxDispatch(resetStateDetectorState());
          response = await ehrAPIService.post(`createResource`, param);

          if (response?.data?.id) {
            debugger;
            let updateParam = { ...response?.data };
            let identifierList = [];

            for (const item of currentReduxTempPatientImageArray) {
              let fileName = item?.objectUrl?.split('/').pop();
              let finalfileName =
                item?.type?.coding?.[0]?.code === 'PPN'
                  ? `${response?.data?.id}/${fileName}`
                  : `${response?.data?.id}/identity/${fileName}`;

              try {
                const finalBlob = await fetch(item?.objectUrl).then(r =>
                  r.blob()
                );

                finalfileName = `${finalfileName}.${
                  finalBlob?.type?.split('/')?.[1]
                }`;
                reduxDispatch(setProgress(true));
                let uploadUrlResponse = await ehrAPIServiceFile.get(
                  `getSingleFileUploadUrl/?fileName=${finalfileName}`
                );

                uploadUrlResponse = uploadUrlResponse?.data;
                await axios({
                  url: uploadUrlResponse,
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                  },
                  data: finalBlob,
                });

                identifierList.push({
                  use: 'usual',
                  type: {
                    coding: [
                      {
                        system: 'http://terminology.hl7.org/CodeSystem/v2-0203',
                        code: item?.type?.coding?.[0]?.code,
                        userSelected: false,
                      },
                    ],
                  },
                  system: 'http://hl7.org/fhir/sid/us-ssn',
                  value: finalfileName,
                });
              } catch (e) {
                console.error(e);
              } finally {
                reduxDispatch(setProgress(false));
              }
            }

            // currentReduxTempPatientImageArray?.forEach(async item => {
            //   let fileName = item?.objectUrl?.split('/').pop();

            //   let finalfileName = '';

            //   if (item?.type?.coding?.[0]?.code === 'PPN') {
            //     finalfileName = `${response?.data?.id}/${fileName}`;
            //   } else {
            //     finalfileName = `${response?.data?.id}/identity/${fileName}`;
            //   }

            //   try {
            //     reduxDispatch(setProgress(true));
            //     let response1 = await ehrAPIServiceFile.get(
            //       `getSingleFileUploadUrl/?fileName=${finalfileName}`
            //     );

            //     const finalBlob = await fetch(item?.objectUrl).then(r =>
            //       r.blob()
            //     );
            //     response1 = response1?.data;
            //     await axios({
            //       url: response1,
            //       method: 'PUT',
            //       headers: {
            //         'Content-Type': 'application/x-www-form-urlencoded',
            //       },
            //       data: finalBlob,
            //     });

            //     identifierList.push({
            //       use: 'usual',
            //       type: {
            //         coding: [
            //           {
            //             system: 'http://terminology.hl7.org/CodeSystem/v2-0203',
            //             code: item?.type?.coding?.[0]?.code,
            //             userSelected: false,
            //           },
            //         ],
            //       },
            //       system: 'http://hl7.org/fhir/sid/us-ssn',
            //       value: finalfileName,
            //     });
            //   } catch (e) {
            //     console.error(e);
            //   } finally {
            //     reduxDispatch(setProgress(false));
            //   }
            // });

            identifierList?.forEach(item => {
              updateParam.identifier = updateParam?.identifier?.filter(
                item1 =>
                  item1?.type?.coding?.[0]?.code !==
                  item?.type?.coding?.[0]?.code
              );
            });

            updateParam.identifier = [
              ...updateParam?.identifier,
              ...identifierList,
            ];

            if (identifierList?.length > 0) {
              response = await ehrAPIService.put(`updateResource`, updateParam);
              currentReduxTempPatientImageArray?.forEach(item => {
                URL.revokeObjectURL(item?.objectUrl);
              });

              reduxDispatch(setCurrentTempPatientImageArray([]));
            }
          }

          if (response?.data?.id) {
            try {
              let payload = {
                resourceType: 'Basic',
                code: {
                  coding: [
                    {
                      system: 'http://enliv.com/code/basic-resource-type',
                      code: 'user.notificationSettings',
                    },
                  ],
                },
                subject: {
                  reference: `Patient/${response?.data?.id}`,
                },
                created: dayjs().format('YYYY-MM-DD'),
                extension: [
                  {
                    url: 'http://enliv.com/notificationSettings',
                    valueString: '{"sms":false,"email":false}',
                  },
                ],
              };
              let responseBasic = await ehrAPIService.post(
                `createResource`,
                payload
              );
            } catch (e) {
              console.error('error:', e);
            }
          }

          if (props?.addNewAnnotationText !== '' && response?.data?.id) {
            const jwtPayload = jwtDecode(localStorage?.getItem(`jwtToken`));

            const generateCategoryCoding = () => {
              let category = [];
              let tempCoding = [];

              let sampleCoding = {
                system: 'http://enliv.com/patient/comment',
                code: 'patient-comment',
                display: 'Patient Comment',
              };
              if (jwtPayload) {
                jwtPayload?.enlivRoles?.map(item => {
                  tempCoding.push({
                    ...sampleCoding,
                    code: `patient-comment-${item}`,
                    display: `Patient Comment - ${_.startCase(item)}`,
                  });
                });
              }
              tempCoding.unshift({ ...sampleCoding });
              category = [{ coding: [...tempCoding] }];
              console.log(category);
              return category;
            };

            let tempCategoryCoding = generateCategoryCoding();
            const payload = {
              resourceType: 'Communication',
              status: 'completed',
              subject: {
                reference: `Patient/${response?.data?.id}`,
              },
              category: [
                {
                  coding: [
                    {
                      system: 'http://enliv.com/patient/comment',
                      code: 'patient-comment',
                      display: 'Patient Comment',
                    },
                  ],
                },
              ],
              sent: dayjs()?.utc()?.format(),
              payload: [
                {
                  contentAttachment: {
                    title: `${jwtPayload?.name} - ${jwtPayload?.enlivRoles
                      ?.map(item => _.startCase(item))
                      .join(',')}`,
                  },
                },
              ],
              note: [
                {
                  text: props?.addNewAnnotationText,
                },
              ],
            };
            payload.category = [...tempCategoryCoding];
            const responseCommunicatoin = await ehrAPIService.post(
              'createResource',
              payload
            );
            props?.setErrorMessageForNewRecord('');
            props?.resetNewAnnotation();
          }
          notificationTitle = 'Patient Record Created Successfully';
          notificationDescription = `Patient Record Created Successfully`;
          navigate(`/ehr/record/${response?.data?.id}?panel=patientPage`);
        }

        if (genderObj?.value === 'female') {
          const patientId = response?.data?.id;
          const patientReference = `Patient/${patientId}`;
          const dateTime = dayjs()?.utc()?.format(`YYYY-MM-DDTHH:mm:ss[Z]`);

          pregnancyObservationSkeleton.effectiveDateTime = dateTime;
          breastfeedingObservationSkeleton.effectiveDateTime = dateTime;
          pregnancyObservationSkeleton.subject.reference = patientReference;
          breastfeedingObservationSkeleton.subject.reference = patientReference;

          let pB = {};
          let bB = {};
          pB.resource = pregnancyObservationSkeleton;
          bB.resource = breastfeedingObservationSkeleton;

          pB.request = {
            method: 'POST',
            url: 'Observation',
          };

          bB.request = {
            method: 'POST',
            url: 'Observation',
          };

          if (patientState?.pregnancyObject?.id) {
            pB.request = {
              method: 'PUT',
              url: `Observation/${patientState?.pregnancyObject?.id}`,
            };
          }

          if (patientState?.breastFeedingObject?.id) {
            bB.request = {
              method: 'PUT',
              url: `Observation/${patientState?.breastFeedingObject?.id}`,
            };
          }

          let mainBundle = {};
          mainBundle.resourceType = 'Bundle';
          mainBundle.type = 'batch';
          mainBundle.entry = [pB, bB];

          await ehrAPIBaseService.post(`fhir/executeBundle`, mainBundle);
        }

        type = 'success';
        flatObjectFromFhirPatient(response?.data).then(pObject => {
          reduxDispatch(setReduxCurrentPatientObject(pObject));
        });
        localStorage.setItem('pateintID', response?.data?.resource?.id);
        dispatch({ type: ACTION_CLOSE_LEFT_FLOATING_DRAWER });
        dispatch({
          type: ACTION_LEFT_DRAWER_JSX,
          payload: <></>,
        });
        reduxDispatch(setEditMode(false));
      } catch (e) {
        let errorCode = `Error: ${e?.response?.status}`;
        notificationDescription = `${errorCode}. Reason: ${e?.response?.data?.issue?.[0]?.diagnostics}`;
        if (!isUndefined(patientState?.id)) {
          notificationTitle = `Patient updating failed`;
        } else {
          notificationTitle = `Patient creation failed`;
        }
      } finally {
        reduxDispatch(setProgress(false));
        generateNotifications({
          title: notificationTitle,
          descriptions: notificationDescription,
          enqueueSnackbar,
          closeSnackbar,
          reduxDispatch,
        });
      }
    }
    // }
  };

  const handleNotifications = (event, name) => {
    setNotificationSetting({
      ...notificationSettings,
      [name]: event?.target?.checked,
    });
    postNotifications({
      ...notificationSettings,
      [name]: event?.target?.checked,
    });
  };

  const postNotifications = async datas => {
    let response;
    try {
      let payload = {
        resourceType: 'Basic',
        code: {
          coding: [
            {
              system: 'http://enliv.com/code/basic-resource-type',
              code: 'user.notificationSettings',
            },
          ],
        },
        subject: {
          reference: `Patient/${patientState?.id}`,
        },
        created: dayjs().format('YYYY-MM-DD'),
        extension: [
          {
            url: 'http://enliv.com/notificationSettings',
            valueString: JSON.stringify(datas),
          },
        ],
      };

      let UserSetting = await ehrAPIBaseService.get(
        `fhir/search/?resourceType=Basic&code=user.notificationSettings&subject=Patient/${patientState?.id}`
      );

      if (UserSetting?.data?.total > 0) {
        payload.id = UserSetting?.data?.entry?.[0]?.resource?.id;
        response = await ehrAPIService.put(`updateResource`, payload);
      } else {
        response = await ehrAPIService.post(`createResource`, payload);
      }
    } catch (e) {
      console.error('error:', e);
    }
    // finally{
    //   console.log('response:',response)
    // }
  };

  useEffect(() => {
    console.log('email', notificationSettings?.email);
  }, [notificationSettings?.email]);

  const titleSection = (
    <Grid item container md={12}>
      <Grid item md={8}>
        <Typography
          sx={{
            color: 'bodyHeadingColor',
          }}
          variant="h6"
        >
          Patient Information{' '}
          <span
            style={{
              fontStyle: 'italic',
            }}
          >
            {patientState?.id ? (
              <Tooltip title={`${patientState?.id}`}>
                <i>{` (Patient Id ${patientState?.id.substr(0, 4)}...)`}</i>
              </Tooltip>
            ) : null}
          </span>
        </Typography>
      </Grid>
      <Grid md={1}></Grid>
      <Grid item container md={2}>
        {/* <Grid item sm={3}>
          <Button
            sx={{ minWidth: '28px', padding: '6px 10px' }}
            variant="contained"
            onClick={() => setShowTaskListScreen(true)}
          >
            <AssignmentTurnedInIcon size={'small'} />
          </Button>
        </Grid>
        <Grid item sm={9}>
          <Button
            onClick={handleOnAssignTask}
            name="assignTask"
            variant="contained"
            fullWidth
          >
            Assign Task
          </Button>
        </Grid> */}
      </Grid>
      {/* <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Typography
          sx={{
            color: 'bodyHeadingColor',
          }}
          variant="h6"
        >
          Patient Information{' '}
          <span
            style={{
              fontStyle: 'italic',
            }}
          >
            {patientState?.id ? (
              <Tooltip title={`${patientState?.id}`}>
                <i>{` (Patient Id ${patientState?.id.substr(0, 4)}...)`}</i>
              </Tooltip>
            ) : null}
          </span>
        </Typography>
        <Button variant="contained">Assign Task</Button>
      </Box> */}
      <Grid item sm={12}>
        <Divider />
      </Grid>
    </Grid>
  );

  const newLeftSection = (
    <Grid container sx={{ border: '0px solid black' }} item md={8}>
      <Grid item xs={12}>
        <FHIRHumanName
          ref={humanNameRef}
          isCreate={_.isUndefined(patientState?.id)}
          isEdit={isEdit}
          nameObject={currentNameObject}
        />
      </Grid>

      <Grid item xs={12} container spacing={1}>
        <Grid item sm={4}>
          {isEdit ? (
            <DateSelectorWithTopLabelComponent
              onChange={handleOnChange}
              {...birthDateValidationObject}
            />
          ) : (
            paperWithTopLabelAndBottomValue({
              label: 'DOB',
              value: dayjs(patientState?.birthDate)?.format(`MM/DD/YYYY`),
            })
          )}
        </Grid>
        <Grid item sm={4}>
          <SelectWithTopLabelComponent
            onChange={handleOnChange}
            {...genderValidationObject}
          />
        </Grid>
        <Grid item sm={4}>
          {isEdit ? (
            <TextFieldWithTopLabelComponent
              onChange={handleOnChange}
              {...ValidationObject1(patientState, selectedVersion)}
            />
          ) : (
            paperWithTopLabelAndBottomValue({
              label: selectedVersion === 'IN' ? 'AADHAAR' : 'SSN',
              value:
                selectedVersion === 'IN'
                  ? patientState?.aadhaar
                  : patientState?.ssn,
            })
          )}
        </Grid>
      </Grid>
      <Grid item container xs={12} spacing={0} mt={3}>
        {patientState?.gender === 'female' && (
          <>
            <Grid item xs={4}>
              <CheckboxComponent
                sx={{
                  marginLeft: '-8px',
                }}
                {...pregnancyCheckboxValidationObject}
                onChange={handleOnChange}
              />
            </Grid>
            <Grid item xs={4}>
              <CheckboxComponent
                sx={{
                  marginLeft: '-8px',
                }}
                {...breastFeedingCheckboxValidationObject}
                onChange={handleOnChange}
              />
            </Grid>
          </>
        )}
      </Grid>
      <Grid item xs={12}>
        <br />
      </Grid>
      <Grid item xs={12}>
        <FHIRAddress
          key={props?.renderAddressField}
          ref={addressRef}
          isEdit={isEdit}
          isCreate={isCreate}
          addressObject={currentAddressObject}
        />
      </Grid>
      <Grid item xs={12}>
        <br />
      </Grid>
      <Grid item xs={12}>
        <FHIRTelecom
          telecomArray={patientState?.telecom}
          ref={telecomRef}
          isEdit={isEdit}
          emailRequired={notificationSettings?.email}
        />
      </Grid>
    </Grid>
  );

  const newRightSection = (
    <Grid
      sx={{
        border: '0px solid black',
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
      }}
      item
      md={3.8}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Checkbox
          disabled={!isIdentityExists}
          checked={isIdentityExists}
          sx={{ color: 'textFieldColor' }}
        />
        <Typography
          onClick={() => {
            props?.handleOnCallback({
              name: 'identityUpload',
              payload: true,
            });
          }}
          sx={{
            textDecoration: 'underline',
          }}
        >
          Upload Identity Document
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Checkbox
          disabled={!isInsuranceExists}
          checked={isInsuranceExists}
          sx={{ color: 'textFieldColor' }}
        />
        <Typography
          onClick={() => {
            props?.handleOnCallback({
              name: 'insuranceUpload',
              payload: true,
            });
          }}
          sx={{
            textDecoration: 'underline',
          }}
        >
          Upload Insurance Identification
        </Typography>
      </Box>

      <SelectWithTopLabelComponent
        {...activeValidationObject}
        onChange={handleOnChange}
      />

      <Box>
        <Typography>
          Primary Care Provider <span style={{ color: red[500] }}>*</span>
        </Typography>
        <FormControl component="fieldset">
          <RadioGroup
            row
            aria-label="radio-buttons"
            name="radio-buttons-group"
            value={searchType}
            onChange={event => {
              setSearchType(event?.target?.value);
            }}
          >
            <FormControlLabel
              value="organization"
              control={<Radio />}
              label="Organization"
            />
            <FormControlLabel
              value="practitioner"
              control={<Radio />}
              label="Practitioner"
            />
          </RadioGroup>
        </FormControl>
        <AsyncAutoCompleteWithTopLabel
          key={patientState?.primaryCareObject?.code}
          {...primaryCareValidationObject}
          onChange={handleOnChange}
          bundlingFunction={list => {
            const optionsList = [];
            for (const item of list) {
              const itemObj = {};
              itemObj.display =
                item?.resource?.resourceType === 'Organization'
                  ? item?.resource?.name
                  : item?.resource?.name?.[0]?.text;
              itemObj.code = `${item?.resource?.resourceType}/${item?.resource?.id}`;
              itemObj.raw = item?.resource;
              optionsList.push(itemObj);
            }
            return optionsList;
          }}
        />
        {/* <Typography
          onClick={() => handleOpenRightProviderDrawers(`billing`)}
          className="cursor mt-5 fs-sm paragraph-underlined"
          sx={{
            color: isDark && 'white',
          }}
        >
          <span style={{ pointerEvents: 'auto' }}>
            {searchType === 'organization'
              ? 'Add new Organization'
              : 'Add new Practitioner'}
          </span>
        </Typography> */}
      </Box>

      <Box>
        <AsyncAutoCompleteWithTopLabel
          key={patientState?.generalPractitionerObject?.code}
          {...generalPractitionerValidationObject}
          onChange={handleOnChange}
          bundlingFunction={list => {
            const optionsList = [];
            for (const item of list) {
              const itemObj = {};
              itemObj.display = item?.resource?.name?.[0]?.text;
              itemObj.code = `${item?.resource?.resourceType}/${item?.resource?.id}`;
              itemObj.raw = item?.resource;
              optionsList.push(itemObj);
            }
            return optionsList;
          }}
        />
        {/* <Typography
          onClick={() => handleOpenRightProviderDrawers(`rendering`)}
          className="cursor mt-5 fs-sm paragraph-underlined"
          sx={{
            color: isDark && 'white',
          }}
        >
          <span style={{ pointerEvents: 'auto' }}>
            {' '}
            Add new General Practitioner
          </span>
        </Typography> */}
      </Box>

      <Box>
        <AsyncAutoCompleteWithTopLabel
          key={patientState?.managingOrganizationObject?.code}
          onChange={handleOnChange}
          {...managingOrganizationValidationObject}
          bundlingFunction={list => {
            const optionsList = [];
            for (const item of list) {
              const itemObj = {};
              itemObj.display = item?.resource?.name;
              itemObj.code = `${item?.resource?.resourceType}/${item?.resource?.id}`;
              itemObj.raw = item?.resource;
              optionsList.push(itemObj);
            }
            return optionsList;
          }}
        />
        {/* <Typography
          onClick={() => handleOpenRightProviderDrawers(`billing_managing`)}
          className="cursor mt-5 fs-sm paragraph-underlined"
          sx={{
            color: isDark && 'white',
          }}
        >
          <span style={{ pointerEvents: 'auto' }}>
            Add new Managing Organization
          </span>
        </Typography> */}
      </Box>

      <AutoCompleteWithTopLabel
        onChange={handleOnChange}
        {...languageValidationObject}
      />

      <AutoCompleteWithTopLabel
        {...maritalStatusValidationObject}
        onChange={handleOnChange}
      />

      <AutoCompleteWithTopLabel
        {...ethnicityValidationObject}
        onChange={handleOnChange}
      />

      <AutoCompleteWithTopLabel
        {...raceValidationObject}
        onChange={handleOnChange}
        toolTip="race"
      />

      <Grid>{patientState?.id && props?.patientAnnotation}</Grid>

      {patientState?.id && (
        <>
          <Grid
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginLeft: 0,
            }}
          >
            <span>SMS Notifications</span>
            <Switch
              checked={notificationSettings?.sms}
              onChange={event => {
                handleNotifications(event, 'sms');
              }}
              disabled={switchLoading}
              color="primary"
            />
          </Grid>
          <Grid
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginLeft: 0,
            }}
          >
            <span>Email Notifications</span>
            <Switch
              checked={notificationSettings?.email}
              onChange={event => {
                handleNotifications(event, 'email');
              }}
              disabled={switchLoading}
              color="primary"
            />
          </Grid>
        </>
      )}

      <FormControlLabel
        name="deceased"
        htmlFor="deceased"
        label="Deceased"
        value="deceased"
        onChange={e => {
          setPatientState({
            ...patientState,
            isDeceased: e?.target?.checked ? true : false,
            deceasedDateTime: e?.target?.checked
              ? patientState?.deceasedDateTime
              : ``,
          });
          setDeceasedClicked(e?.target?.checked);
        }}
        control={<Checkbox checked={patientState?.isDeceased} />}
      />

      <Box sx={{ visibility: patientState?.isDeceased ? 'visible' : 'hidden' }}>
        <DateTimeSelectorWithTopLabelComponent
          flip={true}
          id="deceased"
          resetError={isdeceasedClicked}
          onChange={e => {
            setPatientState({
              ...patientState,
              deceasedDateTime: e?.target?.value,
            });
          }}
          {...deceasedDateTimeValidationObject}
        />
      </Box>

      {/* <Box>{props?.personDetailCard}</Box> */}
      {/* <AsyncAutoCompleteWithTopLabel
                key={patientState?.person?.code}
                onChange={handleOnChange}
                {...contactPersonValidationObject}
                bundlingFunction={list => {
                    const optionsList = [];
                    for (const item of list) {
                        const itemObj = {};
                        itemObj.display = item?.resource?.name?.[0]?.text;
                        itemObj.code = `${item?.resource?.resourceType}/${item?.resource?.id}`;
                        itemObj.raw = item?.resource;
                        optionsList.push(itemObj);
                    }
                    return optionsList;
                }}
            />

            <AutoCompleteWithTopLabel
                onChange={handleOnChange}
                {...relationshipValidationObject}
            /> */}
      {/* {patientState?.id && (
                <LoadingButton
                    fullWidth
                    loading={loading}
                    name="contacts"
                    onClick={() => searchPerson(patientState?.id)}
                    loadingIndicator="searching..."
                    variant="contained"
                    loadingPosition="start"
                    // endIcon={<KeyboardArrowDown />}
                >
                    {loading ? '' : 'Show Contact Persons'}
                </LoadingButton>
            )}

            {personsData?.length > 0 ? (
                <div>
                    <Typography sx={{ fontSize: '14px' }}>
                        Select Contact Person:
                    </Typography>
                    <FormControl sx={{ minWidth: 100 }} size="small" fullWidth>
                        <Select onChange={handlePersonSelect}>
                            {personsData?.[0]?.entry?.length > 0 ? (
                                personsData?.[0]?.entry?.map(person => (
                                    <MenuItem
                                        key={person?.resource?.id}
                                        value={person}
                                    >
                                        {person?.resource?.name?.[0]?.text}
                                    </MenuItem>
                                ))
                            ) : (
                                <MenuItem disabled>
                                    No Contact Persons Available
                                </MenuItem>
                            )}
                        </Select>
                    </FormControl>
                </div>
            ) : null}

            {selectedPerson && (
                <PersonCard
                    key={selectedPerson?.resource?.id}
                    person={selectedPerson}
                    relationship={relationship}
                />
            )} */}
    </Grid>
  );

  return (
    <>
      <Prompt
        when={isPatientStateChanged}
        message="Unsaved changes detected, continue?"
        beforeUnload={isPatientStateChanged}
      />
      <Grid container spacing={2} pl={1} pr={1} mb={8}>
        {showTaskListScreen ? (
          <Fragment>
            <TaskScreenList />
          </Fragment>
        ) : (
          <Fragment>
            {titleSection}
            {newLeftSection}
            {newRightSection}
          </Fragment>
        )}
      </Grid>
    </>
  );
});

export default FHIRPatient;
